// extracted by mini-css-extract-plugin
export default {"icon":"ExternalLink_icon__fd-5s"};